import React from 'react';
import { Typography } from 'antd';
import DraftRenderer from '../draft/draft-renderer';

const { Paragraph } = Typography;

export const Description = ({
  description,
  descriptionJson,
}) => {
  let parsedDesc;
  if (descriptionJson) {
    parsedDesc = JSON.parse(descriptionJson);
  }

  if (!parsedDesc?.blocks || parsedDesc?.blocks.length === 0) {
    return (
      <Paragraph>
        {description}
      </Paragraph>
    );
  }

  return (
    <Paragraph>
      <DraftRenderer content={parsedDesc} />
    </Paragraph>
  );
};
